import styled from 'styled-components';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyleContainerVideo = styled.div`
  margin-right: 0%;
  margin-left: 0%;
  margin-top: 10%;
  ${mediaqueries.greaterThan('tabletLandscape')`
    margin-right: 30%;
    margin-left: 30%;
    margin-top:5%;
  `};
`;

export default StyleContainerVideo;
